import request from '@/utils/request'

export const edit_my_name = (data) => {
    return request({
        url: '/erp/mshop/edit-user-info',
        method: 'post',
        data
    })
}